<template>
    <div class="demo-page" style="background: #FFF">
        <div style="max-width: 400px; margin: 0 auto">
            <a-affix :offset-top="10">
                <div style="margin-bottom: 15px; margin-top: 5px">
                    <a-row>
                        <a-col span="12">
                            <div style="margin-top: 5px;">
                                <RollBack height="18px" :href="'/push/paper/' + search"/>
                            </div>
                        </a-col>
                        <a-col span="12" style="text-align: right;">
                            <a-dropdown v-if="shareable">
                                <ShareAltOutlined class="top-icon"/>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <a-typography-text :copyable="{ text: href }">
                                                分享链接
                                            </a-typography-text>
                                        </a-menu-item>
                                        <a-menu-item @click="()=> openQRCode = true">
                                            分享图片 <PictureTwoTone style="margin-left: 4px"/>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                            <a-tooltip v-else :title="shareTip">
                                <ShareAltOutlined class="top-icon"/>
                            </a-tooltip>
                        </a-col>
                    </a-row>

                </div>
            </a-affix>
            <AudioPlayerWithSubtitles
                    :data="paper"
                    :audioSrc="paper?.audio_url"
                    :subtitles="paper?.audio_parse_info?.audio_axis"
            />
        </div>
    </div>
    <a-modal v-model:open="openQRCode" class="modal-width" :footer="null">
        <a-row align="bottom" :gutter="8">
            <a-col span="22" style="overflow-y: auto;position: relative">
                <div v-if="isPhone" style="text-align: right">
                    <small style="display: none" id="mobile-tip"><SafeIcon type="zhixiangxia"/> 长按保存或分享图片</small>
                </div>
                <div style="background: #F2F2F2; border-radius: 5px; padding: 15px 10px; z-index: 0" id="card">
                    <h3 style="line-height: 24px;">
                        {{paper.title_cn}}
                    </h3>
                    <p>
                                            <span class="paper-primary-text">
                                                <i v-if="paper.journal_title !=='NA'">{{paper.journal_title}}</i>
                                                <span v-if="paper.pub_year">.{{paper.pub_year}}</span>
                                            </span>
                    </p>
                    <div style="border: 1px solid #efefef; border-radius: 5px;">
                        {{paper.summary_brief}}
                    </div>
                    <a-row style="margin-top: 20px" align="bottom">
                        <a-col span="8">
                            <paper-qrcode :href="href"/>
                        </a-col>
                        <a-col span="16" style="text-align: right;line-height: 18px">
                            <PaperSlogan :height="isPhone? 65: 100" align="right"/>
                            <small>扫描二维码，收听完整解读</small>
                        </a-col>
                    </a-row>
                </div>
                <div style="position: absolute;  top: 21px; z-index: 5">
                    <img alt="" width="100%" id="imageElement">
                </div>
            </a-col>
            <a-col span="2">
                <p v-if="isPhone">
                                        <span class="circle" @click="copyImg" v-if="!imgData">
                                            <PictureOutlined/>
                                        </span>
                </p>
                <p v-else>
                                        <span class="circle" @click="copyImg">
                                            <CopyOutlined/>
                                        </span>
                </p>
                <p>
                                        <span class="circle">
                                            <DownloadOutlined @click="generateImg"/>
                                        </span>
                </p>
            </a-col>
        </a-row>
    </a-modal>
</template>

<script>
    import {isDEV, get_args} from "@/utils/request";
    import {
        post_biogpt_upload_share,
        post_biogpt_subscribe_share_paper,
        post_biogpt_paper_upload_info
    } from "@/utils/bioinfo.api";
    import {
        jy_tip,
        exportAsImage,
        downImg,
        // copyImageUrl,
        copyImageToClipboard,
        // captureAsImage,
        checkStatus, copyImageToClipboardByPhone
    } from "@/utils/vue.tool";
    import {ShareAltOutlined} from '@ant-design/icons-vue';
    import RollBack from "@/components/RollBack";
    import PaperQrcode from '../PaperQrcode';
    import {isLogin, isMobile, isPhone, jumpToLogin} from "@/utils/llm.tools";
    import {post_auth_token_confirm} from "@/utils/paper.account";
    import SafeIcon from "@/components/SafeIcon";
    import PaperSlogan from "@/components/PaperSlogan";
    import AudioPlayerWithSubtitles from "./AudioPlayerWithSubtitles";
    import {parseTimeString} from "../../utils/srtParser";
    export default {
        name: "PaperVoice",
        components: {
            RollBack,
            PaperQrcode,
            SafeIcon,
            PaperSlogan,
            AudioPlayerWithSubtitles,
            ShareAltOutlined,
        },
        data(){
            let {upload_no, keyword, paper_no, share_code} = get_args();
            return {
                music: {
                    title: '歌曲名',
                    artist: '歌手',
                    src: '音频URL',
                    cover: '封面图URL',
                    lrc: '[00:10.00]今天呢我们要聊的是一个比较有意思的话题啊，就是如何用多模态的大模型，BiomedGPT来让这个模型在多个生物医学的任务当中，能够同时的去执行并且能够表现的很好。'
                },
                shareTip: 'Voice paper 未完整生成，当前仅支持流式收听，完整生成后可分享。',
                isDEV,
                step: 0,
                showQuanwenText: false,
                checked1: true,
                loading: true,
                openQRCode: false,
                playBoke: false,
                mineruData: {},
                pubmed: {keyword: keyword || ''},
                upload_no: Number(upload_no),
                paper_no: Number(paper_no),
                share_code: share_code,
                shareable: isDEV,
                account: isLogin(),
                href: window.location.href,
                progress: 0,
                height: 60,
                showPPT: false,
                showVedio: false,
                showFullVideo: false,
                showFullText: false,
                paper: {
                    // videoData: 'http://drai.cn/video/demo/20250717_102123_s41586-025-09227-0.mp4',
                    // audioData: 'http://drai.cn/audio/demo/20250717_102123_s41586-025-09227-0.wav'
                },
                open: false,
                modalTitle: '',
                modalData: '',
                imgData: '',
                aiItems: [
                    {title: '要点总结', key: 'summary'},
                    {title: '研究方法', key: 'research_method'},
                    {title: '关键创新点', key: 'key_innovation'},
                    {title: '局限性', key: 'limitations'},
                ],
                searchKeyword: '',
                pageNumber: 1,
                isViewerLoaded: false,
                isPhone: isMobile(),
                search: window.location.search,
            }
        },
        created(){
            let {paper_no, upload_no, share_code} = this;
            if(share_code){
                this.getPaperDetail();
            }
            else post_auth_token_confirm(res=>{
                let {status} = res;
                if(status !== 1) {
                    if(!isDEV) jumpToLogin();
                }
                else {
                    this.getPaperDetail();
                    post_biogpt_upload_share({upload_no, paper_no}, (res)=>{
                        if(res?.data?.share_code) {
                            this.href = window.location.origin + window.location.pathname + window.location.search+ '&share_code=' + (res.data.share_code)
                            this.search += '&share_code=' + (res.data.share_code);
                        }
                    });
                    if(isDEV){
                        let timer = setInterval(()=>{
                            if(this.step > 5){
                                clearInterval(timer);
                                return;
                            }
                            this.step += 1;
                        }, 2000)
                    }
                }
            });

        },
        methods: {
            getPaperDetail(){
                let {paper_no, share_code, upload_no} = this;
                if(upload_no) {
                    if(share_code) post_biogpt_subscribe_share_paper({share_code, paper_no, upload_no}, this.handleDetailRes);
                    else post_biogpt_paper_upload_info({paper_no, upload_no}, this.handleDetailRes);
                }
            },
            handleDetailRes(res){
                this.loading = false;
                let {data, message} = res;
                if(data){
                    let {upload_status: newStatus, video_parse_info, audio_parse_info, embedding} = data;
                    let {audio_axis} = audio_parse_info || {};
                    audio_axis = audio_axis || [];
                    if(data.audio_parse_info) data.audio_parse_info.audio_axis = audio_axis.filter(item=>item.text).map(item=>{
                        return {
                            ...item,
                            ...parseTimeString(item.time)
                        }
                    });
                    this.paper = {...data};
                    this.music.title = data.title_cn;
                    this.music.src = data.audio_url;
                    // this.music.lrc = data.audioa_de
                    this.progress = newStatus;
                    // let showV = video_parse_info?.step === 4;
                    let showV = checkStatus(newStatus, 4);
                    this.showVedio = showV;
                    this.shareable = checkStatus(newStatus, 10);
                    if(!showV) {
                        console.log('======showVedio======', showV, video_parse_info?.step);
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }else if(embedding === 1){
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }
                } else jy_tip(message);
            },

            showModal(title, data){
                this.open = true;
                this.modalTitle = title;
                this.modalData = data;
            },
            copyImg(){
                // generateIm
                if(this.imgData) this.handleCopyImg(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    this.handleCopyImg(this.imgData);
                })
            },
            handleCopyImg(){
                if(isPhone) copyImageToClipboardByPhone(this.imgData, 'imageElement', 'mobile-tip');
                else copyImageToClipboard(this.imgData);
            },
            generateImg(){
                // generateIm
                if(this.imgData) downImg(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    downImg(imgData);
                })
            },
            //pdf相关
            onViewerLoaded() {
                this.isViewerLoaded = true;
                // jy_tip('PDF加载完毕', 'success');
            },
            handleSearchText(searchKeyword) {
                searchKeyword = searchKeyword.trim();
                if (searchKeyword) {
                    if (this.isViewerLoaded) {
                        this.$refs.pdfViewer.highlightKeyword(searchKeyword);
                    }
                }

            },
            clearHighlight() {
                // 通过触发一个空搜索来“清除”高亮，但这并非真正清除，只是高亮了空字符串（视觉上无变化）
                // 另一种思路是直接重新加载iframe，但这会丢失当前页面状态
                if (this.isViewerLoaded) {
                    this.$refs.pdfViewer.highlightKeyword('');
                    this.searchKeyword = '';
                }
            },
            handlePageJump(page) {
                this.pageNumber = typeof page === 'string' ? Number(page?.split('-')[0]): page;
                if (this.isViewerLoaded && this.pageNumber) {
                    this.$refs.pdfViewer.jumpToPage(this.pageNumber);
                }
            },
            handleMinus(mineruData) {
                this.mineruData = {...mineruData};
                console.log('mineruData', mineruData);
                if(mineruData){
                    if (this.$refs.pdfViewer1) {
                        console.log('handleMinus', this.$refs.pdfViewer1.addHighlight);
                        // 添加高亮
                        this.$refs.pdfViewer1.addHighlight( mineruData.page + 1, mineruData);
                    }
                    if(isPhone) {
                        this.showModal(mineruData.name, mineruData.paragraph);
                    }
                }

            },
            handleBoke(){
                this.playBoke = true;
            },
            goToRecent(){
                if(isPhone) window.location.href = '/recent';
            },
            goToPubmed(){
                let href = 'https://pubmed.ncbi.nlm.nih.gov/' + this.paper.pmid;
                window.open(href, '_blank')
            },
            fankui(){
                jy_tip('感谢您的反馈，问题已提交。')
            },
            toggleTab(){
                this.checked1 = !this.checked1;
            },
            showQuanwen(show){
                if(show) {
                    console.log('showQuanwen');
                }
            }
        }
    }
</script>